import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import "./invite.css";
import { inviteMember } from "../../services/InviteMember/InviteMembers";
import { inviteNotification } from "../../services/InviteMember/InviteMembers";
import { useParams } from "react-router-dom";
import { membersSearch } from "../../services/tasks/tasks";
import axios from "axios";
import { toast } from "react-toastify";
function InviteMembers() {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const [noData, setNoData] = useState(false)
  const [data, setData] = useState([]);
  console.log('stet data for', data);
  const [userData, setUserData] = useState()
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  let { id } = useParams();
  console.log('userdata', id)
  const search = (e) => {
    setEmail(e);
    axios.get(`https://roadmap-backend.herokuapp.com/api/getAllUsers/${e}`).then((res) => {
      setData(res.data.data);
    })
  }

  const handleToast = (useName) => {
    toast.success(`
    ${useName} invited successfully `, {
      theme: "colored"
    })
  }
  useEffect(() => {
    let userId = localStorage.getItem("userId")
    console.log('userData', userId)
    setUserData(userId)
  }, [])

  const handleInvite = (id, payload, name) => {
    inviteMember(id, payload).then((res) => {
      if (res.message === "User already exist") {
        return toast.error("User already exists", {
          theme: "colored"
        })
      } else {
        handleToast(name)
      }
    })
    handleClose();
  }

  return (
    <>
      <button className="invite_Button" role="button" onClick={handleShow}>
        Invite
      </button>
      <Modal show={show} onHide={handleClose} style={{ width: "100%" }}>
        <Modal.Header closeButton>
          <Modal.Title className="text-dark">Invite Members</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="text-dark">Email address</Form.Label>
              <input
                type="search"
                className="form-control"
                placeholder="Search for members"
                value={email}
                onChange={(e) => search(e.target.value)}
              />
            </Form.Group>
          </Form>
          <div className="searchedMembers">
            {data?.map((item, index) => {
              let payload = {
                userId: item._id,
                email: item.email,
                profilePicture:item.profilePicture,

              };
              let payloadData = {
                inviteId: item._id,
                userId: userData
              }
              return (
                <div className="searchedMember d-flex justify-content-between" key={index}>
                  <div className="searchedMember__name">
                    <p className="text-dark">{item.name}</p>
                  </div>
                  <div className="searchedMember__email">
                    <p className="text-dark">{item.email}</p>
                  </div>
                  <div className="searchedMember__invite">
                    <button
                      className="invite_Button"
                      onClick={() => { handleInvite(id, payload, item.name); inviteNotification(payloadData) }}
                    >
                      Invite
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
          <div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default InviteMembers;
